export default __webpack_public_path__ + "static/sky-4077231f03b701c06202c578fce00eed.png";